<div class="empty-state-container">
  
  <!-- Image renders ONLY if imageUrl string is provided -->
  <img 
    *ngIf="imageUrl" 
    [src]="imageUrl" 
    alt="Empty state illustration" 
    class="empty-state-image" 
  />
  
  <!-- Heading renders ONLY if heading string is provided -->
  <h3 *ngIf="heading" class="empty-state-heading">
    {{ heading }}
  </h3>
  
  <!-- Subtext renders ONLY if subtext string is provided -->
  <p *ngIf="subtext" class="empty-state-subtext">
    {{ subtext }}
  </p>

</div>


<!-- Fully populated (Matches your screenshot) -->
<!-- <app-no-data
  imageUrl="assets/images/inbox-empty.svg"
  heading="No information available."
  subtext="There is no data to display for this request. Please select another item to view details.">
</app-no-data> -->

<!-- Only heading and subtext (No broken image icon will appear) -->
<!-- <app-no-data
  heading="No Users Found"
  subtext="Try adjusting your search filters.">
</app-no-data> -->